import { render } from "./UpdateEmailSettingsForm.vue?vue&type=template&id=6c2e5b50&scoped=true"
import script from "./UpdateEmailSettingsForm.vue?vue&type=script&lang=js"
export * from "./UpdateEmailSettingsForm.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/whisk/whisk/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c2e5b50"]])

export default __exports__